import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Container, Divider, Header, Icon, Input, Table} from "semantic-ui-react";
import {changeFormatSpot, clear, removeProduit} from "../actions/panier";
import {exportExcel} from "../utils/excel";
import {push} from "react-router-redux";

class Panier extends Component {

  totalTarif() {
    let total = 0;
    this.props.panier.forEach(v => total += v.tarif(this.props.formatSpot));
    return total;
  }

  totalAudience() {
    let total = 0;
    this.props.panier.forEach(v => total += v.audience());
    return total;
  }

  produitRow = (v) => {

    return (
        <Table.Row>
          <Table.Cell><Button icon={'trash'} onClick={() => this.props.removeProduit(v)}/></Table.Cell>
          <Table.Cell>{v.produit.libelle}</Table.Cell>
          <Table.Cell>{v.pressionLibelle()}</Table.Cell>
          <Table.Cell>{v.semaine.code}</Table.Cell>
          <Table.Cell>{v.produit.audienceLibelle}</Table.Cell>
          <Table.Cell>{v.audience().formatFr()}</Table.Cell>
          <Table.Cell>{v.tarif(this.props.formatSpot).formatEuros()}</Table.Cell>
        </Table.Row>
    )
  };

  exportExcel = () => {
    const base64xlsx = exportExcel(this.props.panier, this.props.formatSpot);
    document.location.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64xlsx;
  };

  render() {

    return (
        <Container textAlign='center'>
          <Header color={'teal'} as={'h4'}>
            Format du spot écran :{' '}
            <Input value={this.props.formatSpot} size={'mini'}>
              <Button size='mini' icon='minus' onClick={() => this.props.changeFormatSpot(this.props.formatSpot - 1)}/>
              <input/>
              <Button size='mini' disabled>secondes</Button>
              <Button size='mini' icon='plus' onClick={() => this.props.changeFormatSpot(this.props.formatSpot + 1)}/>
            </Input>
          </Header>
          <Divider/>
          <Table celled color={'teal'} textAlign={'center'}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell/>
                <Table.HeaderCell>Produit</Table.HeaderCell>
                <Table.HeaderCell>Pression</Table.HeaderCell>
                <Table.HeaderCell>Semaine</Table.HeaderCell>
                <Table.HeaderCell>Type d'audience</Table.HeaderCell>
                <Table.HeaderCell>Audience</Table.HeaderCell>
                <Table.HeaderCell>Tarif brut</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.props.panier.map(v => this.produitRow(v))}
            </Table.Body>

            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell>
                  <Button icon={'trash'} size={'small'} color={'red'} onClick={this.props.clearPanier}/>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan='4'/>
                <Table.HeaderCell><Header as={'h4'} color={'orange'}>{this.totalAudience().formatFr()}</Header></Table.HeaderCell>
                <Table.HeaderCell><Header as={'h4'} color={'orange'}>{this.totalTarif().formatEuros()}</Header></Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>

          <Button icon labelPosition='left' color='teal' onClick={this.exportExcel}>
            <Icon name='file excel outline' />
            Export Excel
          </Button>
        </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  semainesVisibles: state.navigation.semainesVisibles,
  formatSpot: state.panier.formatSpot,
  panier: state.panier.panier,
  semainesOccupees: state.panier.semainesOccupees,
  location: state.router.location
});

const mapDispatchToProps = (dispatch) => ({
  changeFormatSpot: (formatSpot) => dispatch(changeFormatSpot(formatSpot)),
  removeProduit: (produit, semaine, pression) => dispatch(removeProduit(produit, semaine, pression)),
  clearPanier: () => dispatch(clear()),
  push: (url) => dispatch(push(url))
});

export default connect(mapStateToProps, mapDispatchToProps)(Panier);
